<template>
  <div class="flex">
    <div v-for="(row, i) in internalValue" :key="idx+'weekD'+i" style="width: 14%; margin-right: 1px;">
      <select
        class="w-full rounded border-gray-300 text-xs font-bold text-center text-blue-800 px-0.5"
        :class="[!row.active?'bg-gray-200 cursor-not-allowed':'', row.weekDetail=='-100'?'bg-red-200':'']"
        v-model="row.weekDetail"
        :disabled="!row.active"
        @change="weekChanged()"
      >
        <option v-for="at in attendanceTypes"
          :key="'at'+at.value"
          :value="at.value"
        >
          {{ at.text }}
        </option>
      </select>
      <div v-if="row.weekDetail=='-100'" class="text-xs font-bold text-red-700 text-center">
        見積り要確認<br>選択肢にない勤務形態
      </div>
    </div>
  </div>
</template>
<script>
  import * as utils from '@libs/utils'
  import { ATTENDANCE_TYPES } from '@libs/constants'

  export default {

    model: {
      prop: 'value',
      event: 'change'
    },

    props: {
      value: {
        type: Array,
        default: () => []
      },
      // 選択された曜日名の配列
      selectedWeeks: {
        type: Array,
        default: () => []
      },
      // 曜日の勤務形態の配列
      weekDetail: {
        type: Array,
        default: () => []
      },
      idx: {
        type: String,
        default: '1'
      }
    },

    computed: {
      internalValue() {
        const week = utils.clone(this.weeks)
        for (let i = 0; i < this.selectedWeeks.length; i++) {
          const s = this.selectedWeeks[i]

          for (let j = 0; j < week.length; j++) {
            const w = week[j]
            if (s == w.name) {
              w.active = true

              for (let k = 0; k < this.value.length; k++) {
                const v = this.value[k]
                if (v.name == s) {
                  w.weekDetail = this.value[k].val
                }
              }
            }
          }
        }
        return week
      }
    },

    watch: {
      selectedWeeks() {
        this.weekChanged()
      }
    },

    data() {
      return {
        weeks: [
          {id: '0', name: '月', active: false, weekDetail: '00'},
          {id: '1', name: '火', active: false, weekDetail: '00'},
          {id: '2', name: '水', active: false, weekDetail: '00'},
          {id: '3', name: '木', active: false, weekDetail: '00'},
          {id: '4', name: '金', active: false, weekDetail: '00'},
          {id: '5', name: '土', active: false, weekDetail: '00'},
          {id: '6', name: '日', active: false, weekDetail: '00'},
        ],
        attendanceTypes: []
      }
    },

    created() {
      const res = utils.clone(ATTENDANCE_TYPES)
      this.attendanceTypes = res.filter((r) => {
        return r.value
      })
    },

    methods: {
      weekChanged() {
        const res = []
        if (this.internalValue && this.internalValue.length) {
          for (let i = 0; i < this.internalValue.length; i++) {
            const row = this.internalValue[i]
            if (row.active) {
              res.push({ name: row.name, val: row.weekDetail })
            }
          }
        }
        this.$emit('change', res)
      }
    }
  }
</script>
<style scoped>

select {
  appearance: none;         /* 標準的な指定 */
  -webkit-appearance: none; /* Safari, Chrome */
  -moz-appearance: none;    /* Firefox */
  background: none;         /* 背景の矢印画像を削除 */
}
</style>